import React from 'react';
import { Link } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { StatusCard } from 'components';
import LandingHeader from './landing-header';
import LandingFooter from './landing-footer';

function LawyerLanding(){
  const classes = buildStyles();
  const target  = {
    pathname  : "/app",
    search    : "?type=reviewer",
  };

  return (
    <Grid container className={classes.root}>
      <LandingHeader/>
      <Grid item container className={classes.lawyerView} alignItems="center" justifyContent="center">
        <Grid item xs={4} container justifyContent="center">
          <StatusCard isVisible={true} status="ok" message="Coming Soon: Lawyer Landing"/>
          <Button component={Link} to={target} className={classes.linkButton} color="primary" variant="contained">Get Started</Button>
        </Grid>        
      </Grid>      
      <LandingFooter/>
    </Grid>
  )
}

export default LawyerLanding;

const buildStyles   = makeStyles(theme => ({
  root   : {
    width   : "100%",
    height  : "100vh",
  },
  lawyerView  : {
    height    : "calc(100vh - 120px)",
    marginTop : 60,
  },
  linkButton  : {
    marginTop   : theme.spacing(3),
  }
}));